// SPDX-License-Identifier: AGPL-3.0-or-later
export const LOCALES = ["en-CA", "fr-CA"];
const money = new Map();
/** "$1,234.56" in English, "1 234,56 $" in French. */
export function formatMoney(cents, locale, currency = "CAD", compact = false) {
    const key = `${locale}|${currency}|${compact}`;
    let f = money.get(key);
    if (!f) {
        f = new Intl.NumberFormat(locale, {
            style: "currency",
            currency,
            currencyDisplay: currency === "CAD" ? "narrowSymbol" : "code",
            ...(compact ? { notation: "compact", maximumFractionDigits: 1 } : {}),
        });
        money.set(key, f);
    }
    return f.format(cents / 100);
}
/** "12.34%" in English, "12,34 %" in French. */
export function formatPercent(percent, locale, digits = 2) {
    return new Intl.NumberFormat(locale, {
        style: "percent",
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(percent / 100);
}
/** Formats an ISO date (YYYY-MM-DD) without shifting it across time zones. */
export function formatDate(iso, locale, style = "short") {
    const [y, m, d] = iso.split("-").map(Number);
    const date = new Date(Date.UTC(y, m - 1, d ?? 1));
    const options = style === "long"
        ? { dateStyle: "full", timeZone: "UTC" }
        : style === "month"
            ? { month: "long", year: "numeric", timeZone: "UTC" }
            : style === "weekday"
                ? { weekday: "short", timeZone: "UTC" }
                : { dateStyle: "medium", timeZone: "UTC" };
    return new Intl.DateTimeFormat(locale, options).format(date);
}
export function monthName(month, locale, width = "long") {
    return new Intl.DateTimeFormat(locale, { month: width, timeZone: "UTC" }).format(new Date(Date.UTC(2026, month - 1, 1)));
}
/** Short weekday names, Sunday first. */
export function weekdayNames(locale) {
    // 2026-10-04 is a Sunday.
    return Array.from({ length: 7 }, (_, i) => new Intl.DateTimeFormat(locale, { weekday: "short", timeZone: "UTC" }).format(new Date(Date.UTC(2026, 9, 4 + i))));
}
//# sourceMappingURL=format.js.map